import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SettingService} from './setting.service';
import {AuthenticationService} from './authentication.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class ApiService {

  defaultHeaders: HttpHeaders;
  apiBasePath: string;

  constructor(private  http: HttpClient,
              private authenticationService: AuthenticationService,
              private setting: SettingService) {
    this.apiBasePath = setting.apiBasePath;
  }

  get defaultOptions(): any {
    this.defaultHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authenticationService.accessToken
    });

    return {headers: this.defaultHeaders};
  }


  get(url: string): Observable<any> {
    return this.http
      .get(this.apiBasePath + url, this.defaultOptions);
  }

  post(url: string, data: any): Observable<any> {

    return this.http
      .post(this.apiBasePath + url, data, this.defaultOptions);
  }

  put(url: string, data: any): Observable<any> {
    return this.http
      .put(this.apiBasePath + url, data, this.defaultOptions);
  }

  delete(url: string): Observable<any> {
    return this.http
      .delete(this.apiBasePath + url, this.defaultOptions);
  }


}
